import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig, AxiosError } from 'axios';
import { tokenService } from './tokenService';
import { handleResponseError } from './apiRefreshHandler';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api: AxiosInstance = axios.create({
    baseURL: `${apiBaseUrl}/api`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = tokenService.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

// Response interceptor: bei 401 erst Refresh-Token einloesen und Original-
// Request retryen. Erst wenn der Refresh selbst scheitert (oder bereits
// retried wurde) ist der User wirklich ausgeloggt — sonst verliert er bei
// jedem 1h-TTL-Ablauf seine Arbeit (siehe Walter / #295).
api.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => handleResponseError(error, (config) => api(config)),
);

export default api;
